/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { getUserAvatar } from '@e180/domain/lib/user/util';

import {
  getConversationTopicAuthor,
  getConversationOtherParticipants,
} from 'src/shared/domain/conversation/util/conversationUtil';
import GroupAvatar from 'src/shared/ui/component/image/GroupAvatar';

import type { Conversation } from '@e180/domain/lib/conversation/type';
import type { AvatarProps } from 'src/shared/ui/component/image/type/avatarTypes';

type Props = AvatarProps & {
  conversation: Conversation,
};

const ConversationAvatar = ({
  layoutClass,
  variant,
  alt,
  conversation,
}: Props): React.Node => {
  const author = getConversationTopicAuthor(conversation);
  const others = getConversationOtherParticipants(conversation, author);

  return (
    <GroupAvatar
      layoutClass={layoutClass}
      variant={variant}
      alt={alt}
      src={[author, ...others].map(getUserAvatar)}
    />
  );
};

export default compose(React.memo)(ConversationAvatar);
